export const AC_URL = {
  ICO_SCRIPT_ID: 'autocanada-ico-js',
  ICO_SCRIPT_URL: '/scripts/ac-ico-sdk-qa-v1.min.js',
  BOS_EN: '/en/billofsale/kijiji',
  BOS_FR: '/fr/billofsale/kijiji',
}

export const AUTOCAN_CTA_IDS = {
  BOS_LANDING_PAGE_CVC: 'web-bos-landing-page-car-value-calculator',
  BOS_LANDING_PAGE_SMC: 'web-bos-landing-page-sell-my-car',
  ICO_LANDING_PAGE_CVC: 'web-ico-landing-page-car-value-calculator',
  ICO_LANDING_PAGE_SMC: 'web-ico-landing-page-sell-my-car',
  VALUE_ESTIMATE_SRP: 'web-value-estimate-srp',
  VALUE_ESTIMATE_LANDING_PAGE_CVC: 'web-value-estimate-landing-page-car-value-calculator',
}
